import PropTypes from 'prop-types'
import React from 'react'
import MultiSelectPillList from '../MultiSelectPillList'

const propTypes = {
  /**
   * id of the multi select
   */
  id: PropTypes.string.isRequired,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * user options of the multi select
   */
  options: PropTypes.arrayOf(PropTypes.shape),
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Selected values
   */
  values: PropTypes.arrayOf(PropTypes.string),
  /**
   * Array of validation error messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
}

function UserMultiselect(props) {
  const { id, title = null, options = [], onChange, values = [], errors = [], ...rest } = props ?? {}

  const formatOptionLabel = (option) => <span className="text-break-all">{option?.label}</span>

  return (
    <MultiSelectPillList
      id={id}
      title={title}
      options={options}
      onChange={onChange}
      values={values}
      formatOptionLabel={formatOptionLabel}
      errors={errors}
      {...rest}
    />
  )
}

UserMultiselect.propTypes = propTypes

export default UserMultiselect
